import { Inbox } from 'lucide-react'

export function Loading({ label = 'Carregando dados…' }: { label?: string }) {
  return <div className="loading" role="status" aria-live="polite"><span className="spinner"/><p>{label}</p></div>
}

export function Empty({ children }: { children: string }) {
  return <div className="empty-state"><span className="empty-icon" aria-hidden="true"><Inbox/></span>{children}</div>
}
